import React from 'react';
import { Layout } from 'antd';
import { PUBLIC_PATHS } from '../../utils/constant';
import { formatMessage } from '../../utils/text';
import './Footer.less';

const { Footer } = Layout;

function FooterComponent() {
  return (
    <Footer className="page-footer">
      <div className="page-footer__line">
        <span className="page-footer__prefix">
          {formatMessage('footer.companyPrefix')}
        </span>{' '}
        <img
          className="page-footer__mark"
          src={PUBLIC_PATHS.images.poweredByCorelab}
          alt="CORELAB"
          width={154}
          height={28}
        />
      </div>
    </Footer>
  );
}

export default FooterComponent;
